export const getSanitizedLocation = (location: string) =>
  location !== '/' ? location.replace(/\/$/, '') : location
